import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { I18nProvider } from './i18n'
import { AuthProvider } from './auth'
import { ThemeProvider } from './theme/ThemeContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { installGlobalErrorHandlers } from './utils/logger'
import { initSentry } from './lib/sentry'
import './index.css'
import AppRouter from './AppRouter.tsx'
import { registerSW } from 'virtual:pwa-register'
import { initializeWebAds } from './lib/h5Ads'

initSentry()
installGlobalErrorHandlers()
registerSW({ immediate: true })

void initializeWebAds()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <HelmetProvider>
        <ThemeProvider>
          <I18nProvider>
            <AuthProvider>
              <BrowserRouter>
                <AppRouter />
              </BrowserRouter>
            </AuthProvider>
          </I18nProvider>
        </ThemeProvider>
      </HelmetProvider>
    </ErrorBoundary>
  </StrictMode>,
)
